<!-- Component for developers to store survey GUIDs -->

<template>
    <div tabindex="0" data-guid-pocket aria-hidden="true">
        <div>
            <strong data-button-title>Surveys</strong>
        </div>
        <ul>
            <li v-for="(value, key) in guids" :key="`gp-${key}`">
                <span @click="surveyClick(value.guid)">{{ value.name }}</span>
                <font-awesome-icon icon="times" @click="surveyDelete(value.name)" />
            </li>
        </ul>
        <div>
            <strong>Nieuwe Survey</strong>
        </div>
        <div>
            <input placeholder="Naam" type="text" v-model="newName" />
        </div>
        <div>
            <input placeholder="Guid" type="text" v-model="newGuid" @key.enter="addGuid" />
        </div>
        <div>
            <button @click="addGuid" @key.enter="addGuid" data-button>Toevoegen</button>
        </div>
    </div>
</template>

<script>
export default {
    name: `guid-pocket`,
    data() {
        return {
            guids: [],
            newName: ``,
            newGuid: ``,
            wrongKeys: [
                // The localstorage object has several keys that are not the guids stored. We don't want them
                `loglevel:webpack-dev-server`,
                `kljlk`,
                `length`,
                `key`,
                `getItem`,
                `setItem`,
                `removeItem`,
                `clear`,
                `surveyid`,
            ],
        };
    },
    methods: {
        addGuid: function () {
            let newGuid = { name: this.newName, guid: this.newGuid };

            this.guids.unshift(newGuid);
            localStorage.setItem(this.newName, this.newGuid);

            this.newName = ``;
            this.newGuid = ``;
        },
        surveyClick: function (guid) {
            location.href = `${window.location.origin}?surveyid=${guid}`;
        },
        surveyDelete: function (name) {
            window.localStorage.removeItem(name);
            this.guids = this.guids.filter((guid) => guid.name !== name);
        },
    },
    created() {
        for (var key in localStorage) {
            if (this.wrongKeys.includes(key)) continue;

            this.guids.push({
                name: key,
                guid: localStorage[key],
            });
        }
    },
};
</script>

<style scoped>
[data-guid-pocket] {
    position: fixed;
    top: 15px;
    left: 15px;
    border: 1px solid #ebebeb;
    background: #f8f8f8;
    border-radius: 5px;
    box-shadow: 0 5px 8px #ccc;
    padding: 15px;
    z-index: 10000;
    height: 45px;
    overflow: hidden;
    width: 100px;
    cursor: pointer;

    > * {
        margin: 15px 0;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    [data-button] {
        height: auto;
    }

    &:focus,
    &:focus-within {
        height: auto;
        width: auto;
        cursor: auto;
    }
}

[data-button-title] {
    word-break: normal;
}

svg {
    color: darkred;
}

ul {
    display: flex;
    flex-direction: column;
    padding-left: 0;
}

li {
    padding: 10px 0;
    border-top: 1px solid #333;
    cursor: pointer;
    display: flex;
    justify-content: space-between;

    &:last-child {
        border-bottom: 1px solid #333;
    }

    &:hover {
        background: #eaeaea;
        transition: 0.2s;
    }
}
</style>